import { DOWNLOAD, PRINT } from 'NewAngular/constants/core.constants';
import { Partner, } from 'ChartApp/ts/apps/fund-chart-creator/interfaces/fund-chart-creator.interface';
// partner specific constants
export const PARTNER_CHART_SIZES = {
    [Partner.FOOL]: [
        { label: 'Standard (720 px wide)', value: 'fool_720' },
        { label: 'Large (1015 px wide)', value: 'fool_1015' },
    ],
    [Partner.MILLIONACRES]: [
        { label: 'Standard (720 px wide)', value: 'millionacres_720' },
        { label: 'Large (1015 px wide)', value: 'millionacres_1015' },
    ],
    [Partner.SEEKING_ALPHA]: [{ label: 'Standard (635 px wide)', value: 'seeking_alpha_635' }],
    [Partner.SEEKING_ALPHA_IFRAME]: [{ label: 'Standard (635 px wide)', value: 'seeking_alpha_635' }],
    [Partner.STREET_AUTHORITY]: [{ label: 'Standard (550 px wide)', value: 'street_authority_550' }],
    [Partner.THE_STREET]: [
        { label: 'Small (290 px wide)', value: 'the_street_290' },
        { label: 'Medium (340 px wide)', value: 'the_street_340' },
        { label: 'Standard (575 px wide)', value: 'the_street_575' },
        { label: 'Large (590 px wide)', value: 'the_street_590' },
    ],
    [Partner.FORBES]: [{ label: 'Standard (618 px wide)', value: 'forbes_618' }],
    [Partner.WEALTHTRACK]: [{ label: 'Standard (590 px wide)', value: 'wealthtrack_590' }],
};
export const FUND_CHART_CREATOR_EXPORT_OPTIONS = {
    title: {
        label: 'Export',
        icon: 'icon-export',
    },
    list: [
        {
            type: 'option',
            label: 'Download Image',
            value: DOWNLOAD,
            icon: 'icon-download',
        },
        {
            type: 'option',
            label: 'Print',
            value: PRINT,
            icon: 'icon-print',
        },
    ],
};
export const PARTNERS_WITH_EMBED_JS = [Partner.SEEKING_ALPHA_IFRAME];
